const Paths = {
  // TRIP CATEGORIES
  TRIP_CATEGORIES: '/trip-categories',
  TRIP_CATEGORIES_API: '/cms/trip-categories',
  TRIP_CATEGORIES_LIST: '/trip-categories/list',
  TRIP_CATEGORIES_ADD: '/trip-categories/add',
  TRIP_CATEGORIES_EDIT: '/trip-categories/:id',
  // PLACE CATEGORIES
  PLACE_UTILITIES: '/place-utilities',
  PLACE_UTILITIES_API: '/cms/place-categories',
  PLACE_UTILITIES_LIST: '/place-utilities/list',
  PLACE_UTILITIES_ADD: '/place-utilities/add',
  PLACE_UTILITIES_EDIT: '/place-utilities/:id',
  // ACTIVITY
  ACTIVITIES: '/activities',
  ACTIVITIES_API: '/cms/activities',
  ACTIVITIES_LIST: '/activities/list',
  ACTIVITIES_ADD: '/activities/add',
  ACTIVITIES_EDIT: '/activities/:id',
  // ACTIVITY CATEGORY
  ACTIVITY_CATEGORIES_API: '/cms/activity-categories',
};

export default Paths;
